import { useQuery, useQueryClient, QueryClient } from 'react-query'
import { BigNumber } from 'bignumber.js'
import { queryLpTokenBalanceOf } from 'hooks/boost-farm/useLpTokenBalanceOf'
import { getCraftsmanContract } from 'utils/contractHelpers'
import { getCraftsmanAddress, getCraftsmanV2Address, getAddress } from 'utils/addressHelpers'
import { QueryKey } from 'config/constants/queryKey'
import { SerializedFarmConfig } from 'config/constants/types'

export const queryKeyFarmTotalSize = (farm: SerializedFarmConfig) => [QueryKey.FARM_TOTAL_SIZE, farm.pid]
const queryFnFarmTotalSize = async (queryClient: QueryClient, farm: SerializedFarmConfig) => {
  if (farm.version === 2) {
    const craftsmanContract = getCraftsmanContract()
    const [amountRaw] = await craftsmanContract.userInfo(farm.pid, getCraftsmanV2Address())
    return new BigNumber(amountRaw.toString())
  }

  // farm.version === 1:
  const lpToken = getAddress(farm.lpAddresses)
  const craftsmanAddr = getCraftsmanAddress()
  return queryLpTokenBalanceOf(queryClient, lpToken, craftsmanAddr)
}
export const useFarmTotalSize = (farm: SerializedFarmConfig) => {
  const queryClient = useQueryClient()
  return useQuery(queryKeyFarmTotalSize(farm), () => queryFnFarmTotalSize(queryClient, farm))
}
export const queryFarmTotalSize = async (queryClient: QueryClient, farm: SerializedFarmConfig) =>
  queryClient.fetchQuery(queryKeyFarmTotalSize(farm), () => queryFnFarmTotalSize(queryClient, farm))
